import { useEffect, useRef, useState } from "react";
import { Send, Sparkles, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Markdown } from "@/components/Markdown";

const SUGGEST = {
  general: ["Quali promozioni generano volume e quali solo sconto?", "Quali segmenti dovrei attivare questo mese?", "Quali punti vendita richiedono un intervento urgente?", "Proponi una campagna punti per riattivare gli inattivi"],
  store: ["Le promo qui rendono più o meno della rete?", "Come aumento la penetrazione fedeltà in questo negozio?", "Quali promo proporre nei giorni deboli?", "Confrontalo con il miglior punto vendita"],
  customer: ["Le promozioni lo fidelizzano o compra solo in offerta?", "Quali 3 offerte personalizzate gli invieresti?", "Scrivi un SMS promozionale per questo cliente", "Qual è il rischio che smetta di comprare?"],
};

const SUGGEST_PROMO = {
  general: ["Quali codici promo eliminerei?", "Dove la promo genera volume reale?", "Come ridurre lo sconto senza perdere clienti?"],
  store: ["Quali promo spingere in questo negozio?", "Lo sconto medio qui è troppo alto rispetto alla rete?", "Proponi un calendario promo per il prossimo mese"],
  customer: ["È un cacciatore di offerte?", "Quali promo lo hanno fidelizzato al prodotto?", "Che offerta gli farei per fargli comprare a prezzo pieno?"],
};

export const AiConversation = ({ analysis, streaming, onAsk, modelLabel }) => {
  const [text, setText] = useState("");
  const end = useRef(null);
  const visible = (analysis?.messages || []).filter((m) => !m.hidden);
  useEffect(() => { if (visible.length > 1) end.current?.scrollIntoView({ behavior: "smooth", block: "end" }); }, [visible.length]);

  const send = (t) => { if (!t.trim() || streaming) return; onAsk(t.trim()); setText(""); };

  return (
    <div className="flex min-w-0 flex-col" data-testid="ai-conversation">
      <div className="space-y-5 p-5">
        {visible.map((m, i) => m.role === "assistant" ? (
          <div key={i} className="flex gap-3" data-testid="ai-message-assistant">
            <div className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-blue-600 text-white"><Sparkles className="h-3.5 w-3.5" /></div>
            <div className="min-w-0 flex-1 overflow-x-auto">
              {m.content ? <Markdown text={m.content} /> : m.status === "running" ? <div className="flex items-center gap-2 text-sm text-slate-400"><span className="ai-dots" />L'agente sta analizzando i dati…</div> : null}
              {m.content && m.status === "running" && <div className="mt-2 flex items-center gap-2 text-xs text-slate-400"><span className="ai-dots" />sta scrivendo…</div>}
              {m.status === "error" && <div data-testid="ai-message-error" className="mt-2 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-700">{m.error || "Risposta interrotta"}{m.content ? " · la risposta potrebbe essere incompleta" : ""}</div>}
            </div>
          </div>
        ) : (
          <div key={i} className="flex justify-end gap-3" data-testid="ai-message-user">
            <div className="max-w-[80%] rounded-2xl rounded-tr-sm bg-slate-900 px-4 py-2.5 text-sm text-white">{m.content}</div>
            <div className="grid h-7 w-7 shrink-0 place-items-center rounded-lg bg-slate-100 text-slate-500"><User className="h-3.5 w-3.5" /></div>
          </div>
        ))}
        <div ref={end} />
      </div>
      <div className="sticky bottom-0 border-t border-slate-100 bg-white/95 p-4 backdrop-blur">
        <div className="mb-3 flex gap-2 overflow-x-auto pb-1 sm:flex-wrap">
          {((analysis?.kind === "promo" ? SUGGEST_PROMO : SUGGEST)[analysis?.scope_type] || []).map((s) => (
            <button key={s} data-testid="ai-suggestion" disabled={streaming} onClick={() => send(s)}
              className="shrink-0 rounded-full border border-slate-200 px-3 py-1 text-xs text-slate-600 transition-colors hover:border-blue-300 hover:bg-blue-50 hover:text-blue-700 disabled:opacity-50">{s}</button>
          ))}
        </div>
        {modelLabel && <div className="mb-1.5 text-[11px] text-slate-400" data-testid="ai-followup-model">Risponde: {modelLabel}</div>}
        <div className="flex gap-2">
          <Textarea data-testid="ai-followup-input" rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder="Fai una domanda di approfondimento sui dati…"
            onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(text); } }} className="resize-none" />
          <Button data-testid="ai-followup-send" onClick={() => send(text)} disabled={streaming || !text.trim()} className="h-auto bg-blue-600 hover:bg-blue-700"><Send className="h-4 w-4" /></Button>
        </div>
      </div>
    </div>
  );
};
